export const gatewaysListsResultsAreReadyButEmpty = (
  gatewaysListsResultsReady,
  connectedGatewaysListData,
) => {
  return (
    gatewaysListsResultsReady &&
    connectedGatewaysListData &&
    connectedGatewaysListData.length === 0
  );
};
